import { render } from "./Slide11.vue?vue&type=template&id=ffb735de&scoped=true"
import script from "./Slide11.vue?vue&type=script&lang=js"
export * from "./Slide11.vue?vue&type=script&lang=js"

import "./Slide11.vue?vue&type=style&index=0&id=ffb735de&lang=scss&scoped=true"
import "./Slide11.vue?vue&type=style&index=1&id=ffb735de&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb735de"]])

export default __exports__